import React, { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useIntl } from 'react-intl'

import { MANAGERS_TABLE_ACTIONS, MANAGERS_TABLE_COLUMNS } from '../../constants'
import { paymentDataPreparation } from '../../logics'
import { TableUrlPagination } from '../../../../ui'
import { TableActions, TableActive } from '../table-actions'

const getLookup = (combo) => {
  let lookup = {}
  combo.forEach((item) => (lookup[item.key] = item.value))
  return lookup
}

export const ManagersTable = () => {
  const intl = useIntl()
  const {
    data,
    search,
    pagination: { total_comercializadoras: totalEntries },
    isLoading,
  } = useSelector((state) => state.managers)
  const combos = useSelector((state) => state.combos)

  const formattedData = useMemo(
    () => paymentDataPreparation(data, { intl }, combos),
    [data, intl, combos]
  )

  const formattedColumns = useMemo(
    () =>
      [...MANAGERS_TABLE_COLUMNS, ...MANAGERS_TABLE_ACTIONS].map((column) => {
        const baseColumn = {
          accessorKey: column.field,
          header: intl.formatMessage({
            id: `pages.managers.table.columns.${column.field}.title`,
          }),
          size: column.width,
          minSize: column.width,
          maxSize: column.width,
        }

        if (column.field === 'actions') {
          return {
            ...baseColumn,
            Cell: (props) => <TableActions {...props} />,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
          }
        }

        if (column.field === 'active') {
          return {
            ...baseColumn,
            Cell: (props) => <TableActive {...props} />,
            muiTableBodyCellProps: { align: 'center' },
            muiTableHeadCellProps: { align: 'center' },
          }
        }

        if (column.comboId && combos[column.comboId]?.data) {
          const lookup = getLookup(combos[column.comboId].data)
          return {
            ...baseColumn,
            Cell: ({ cell }) => {
              const value = cell.getValue()
              return <span>{lookup[value] ?? value ?? '--'}</span>
            },
          }
        }

        return {
          ...baseColumn,
          Cell: ({ cell }) => <span>{cell.getValue() ?? '--'}</span>,
        }
      }),
    [combos, intl]
  )

  const tableOptions = useMemo(
    () => ({
      toolbar: false,
      fixedColumns: {
        right: 2,
      },
      draggable: false,
    }),
    []
  )

  return (
    <TableUrlPagination
      columns={formattedColumns}
      options={tableOptions}
      totalEntries={totalEntries}
      search={search}
      data={formattedData}
      isLoading={isLoading}
    />
  )
}
